import { createContext, useContext } from "react"
import { DateTime } from "@/lib/dates"
import { UsersUserProfileLanguageChoices } from "@/api/graphql/types"

type FormatNumberType = (
	number: number | bigint,
	options?: Intl.NumberFormatOptions | undefined,
) => string
type FormatCurrencyType = (
	number: number | bigint,
	options?: Intl.NumberFormatOptions | undefined,
) => string

export interface LangContextType {
	lang: UsersUserProfileLanguageChoices
	formatNumber: FormatNumberType
	formatCurrency: FormatCurrencyType
	formatDate: (
		date: DateTime,
		options?: { variant?: "pretty" | "verbose" | "computer" },
	) => string
	setLang: (newLang: UsersUserProfileLanguageChoices) => void
}

export const LangContext = createContext<LangContextType>(null!)

export const useLang = () => useContext(LangContext)
